import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { sharedTypographyStyles, FONT_SIZE_SECTION_HEADER } from '../sharedStyles';
import {
  Avatar,
  Box,
  Card,
  CardHeader,
  CardContent,
  Collapse,
  Divider,
  Grid,
  LinearProgress,
  Typography,
  makeStyles
} from '@material-ui/core';
import SchoolIcon from '@material-ui/icons/School';
import { useSelector } from "react-redux"

const useStyles = makeStyles((theme) => ({
  ...sharedTypographyStyles,
  root: {
    height: '100%',
  },
  card: {
    background: 'transparent',
    borderRadius: 14,
    boxShadow: 'none',
  },
  avatar: {
    backgroundColor: '#6a8caf',
    height: 'clamp(20px, 2.2vw, 36px)',
    width: 'clamp(20px, 2.2vw, 36px)',
  },
  avatarIcon: {
    color: '#fff',
    fontSize: 'clamp(14px, 1.4vw, 22px)',
  },
  cardHeaderRoot: {
    alignItems: 'center',
  },
  cardHeaderTitle: {
    color: '#002D55',
    fontWeight: 'bold',
    fontSize: 'clamp(15px, 1.4vw, 22px)',
  },
  drawerRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    userSelect: 'none',
    padding: 'clamp(12px, 0.75vw, 12px) clamp(12px, 1.05vw, 16px)',
    minHeight: 'clamp(42px, calc(24px + 1.45vw), 56px)',
    backgroundColor: '#FFFFFF',
    borderRadius: 14,
    border: '1px solid #dce9f4',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: '#e8f0f9',
    },
  },
  drawerArrow: {
    marginLeft: 'clamp(8px, 0.7vw, 12px)',
    fontSize: 'clamp(14px, 1.15vw, 18px)',
    transition: 'transform 0.2s ease',
    display: 'inline-block',
  },
  drawerCard: {
    background: 'linear-gradient(90deg, #dce4eb, #d7d4cf)',
    borderRadius: '0 0 14px 14px',
    boxShadow: '0 2px 12px rgba(106,140,175,0.07)',
    padding: 16,
    width: '100%',
    marginTop: 0,
  },
}));
  
const Treatmentadvices = ({ className }) => {
  const classes = useStyles();
  const [token, _] = useState(useSelector(state => state.auth.token));
  const [advices, setAdvices] = useState([]);
  const [openAdvice, setOpenAdvice] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const fetchAdvicesData = async () => {
    setIsLoading(true);
    const response = await fetch("https://api.virtus-one.com/treatment/advices/", {
      headers: {
        "Authorization": `Token ${token}`
      },
      method: "GET",
    });

    if (response.ok) {
      const data = await response.json();
      console.log(data)
      setAdvices(data[0]["advices"])

    } else {
      alert("ERROR")
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchAdvicesData();
  }, []);

  return (
    <Grid className={`${classes.root} ${className || ''}`}>
      <Card className={classes.card}>
        {/*<CardHeader
          className={classes.cardHeaderRoot}
          avatar={<Avatar className={classes.avatar}><SchoolIcon className={classes.avatarIcon} /></Avatar>}
          title={<span className={classes.cardHeaderTitle}>Advice & education</span>}
          style={{ marginBottom: 5, padding: 10, borderBottom: '2px solid #fb741a', alignItems: 'center' }}
        />*/}
        <CardContent style={{ padding: 0 }}>
          <Grid direction="column">
            {isLoading && <LinearProgress />}
            {!isLoading && advices.length === 0 && (
              <Typography className={classes.subText} style={{ opacity: 0.7 }}>
                No advice available yet.
              </Typography>
            )}
            {advices.map((advice, idx) => (
              <Box key={`${idx}-${advice.title || 'advice'}`} style={{ marginBottom: 12 }}>
                <div
                  className={classes.drawerRow}
                  style={{
                    borderRadius: openAdvice === idx ? '14px 14px 0 0' : 14,
                  }}
                  role="button"
                  tabIndex={0}
                  aria-expanded={openAdvice === idx}
                  onClick={() => setOpenAdvice(openAdvice === idx ? null : idx)}
                  onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                      event.preventDefault();
                      setOpenAdvice(openAdvice === idx ? null : idx);
                    }
                  }}
                >
                  <Typography style={{ color: '#002D55', fontWeight: 600, fontSize: FONT_SIZE_SECTION_HEADER, margin: 0, lineHeight: 1.2 }}>
                    {advice.title}
                  </Typography>
                  <span className={classes.drawerArrow} style={{ color: openAdvice === idx ? '#FF7F27' : '#002D55', transform: openAdvice === idx ? 'rotate(0deg)' : 'rotate(-90deg)' }}>{openAdvice === idx ? '▼' : '▶'}</span>
                </div>
                <Collapse in={openAdvice === idx} timeout="auto" unmountOnExit>
                  <Box className={classes.drawerCard}>
                    <Typography className={classes.subText}>{advice.advice}</Typography>
                  </Box>
                </Collapse>
              </Box>
            ))}
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
};

Treatmentadvices.propTypes = {
  className: PropTypes.string
};

export default Treatmentadvices;
